<script>
import { HorizontalBar } from "vue-chartjs";
// import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  extends: HorizontalBar,
  props: ["title", "data", "labels"],
  data() {
    return {
      color: [
        "#FF0000",
        "#FF7F50",
        "#FFA500",
        "#FFFF00",
        "#90EE90",
        "#66CDAA",
        "#00FFFF",
        "#87CEEB",
        "#4169E1",
        "#0000FF",
      ],
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          // plugins: [ChartDataLabels],
          labels: this.$props.labels,
          datasets: [
            {
              label: this.$props.title,
              backgroundColor: "#5E83BA",
              data: this.$props.data,
              datalabels: {
                display: false,
              },
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: "index",
            intersect: false,
          },
          // plugins: {
          //   datalabels: {
          //     color: "white",
          //     display: function (context) {
          //       return context.dataset.data[context.dataIndex] > 15;
          //     },
          //     font: {
          //       weight: "bold",
          //     },
          //     formatter: Math.round,
          //   },
          // },

          // legend: {
          //   display: false,
          // },
          // plugins: {
          //   datalabels: {
          //     color: "black",
          //     anchor: "end",
          //     align: "right",
          //     offset: 10,
          //     font: {
          //       weight: "bold",
          //       size: 15,
          //     },
          //   },
          // },
        }
      );
    },
  },
};
</script>
